import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import cl from './BaseSimpleItemEditor.module.css'
import ServerManager from "../../API/ServerManager";
import BaseSimpleItemEditorHeader from "./BaseSimpleItemEditorHeader";
import {Alert, LinearProgress} from "@mui/material";
import BaseSimpleItemEditorFooter from "./BaseSimpleItemEditorFooter";

const BaseSimpleItemEditor = forwardRef(({
                                    modeApiName1,
                                    ItemFormComponent,
                                    renderFooterFunc,
                                    isAddSubMode,
                                    editItemId,
                                    searchByIdMode,
                                    onAdd,
                                    onDelete,
                                    onSave,
                                    setSnackbarData,
                                    setLoadingOverlayData,
                                    pageOptions,
                                    testReadOnlyFunc,
                                    headerCustomTextFunc
                                }, ref) => {

    useImperativeHandle(ref, () => ({
        tryValidateAndGetFormData: tryValidateAndGetFormData,
        tryGetInitData: tryGetInitData,
    }));

    const [isLoading, setIsLoading] = React.useState(!isAddSubMode);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [formData, setFormData] = useState(null);
    const [formKey, setFormKey] = useState(0);
    const formControlRef = useRef(null);

    const [readOnlyMode, setReadOnlyMode] = useState(!isAddSubMode);

    // получение данных с сервера (если режим редактирования) (один раз)
    useEffect(() => {
        async function fetch() {
            setIsLoading(true);
            setFormData(null);
            try {
                const itemData = await ServerManager.getSimpleModeItem(modeApiName1, editItemId);
                if (!ignore) {
                    setFormData(itemData);
                    setReadOnlyMode(testReadOnlyFunc ? testReadOnlyFunc(itemData) : false);
                }
            } catch (error) {
                if (!ignore) {
                    if (searchByIdMode)
                        setErrorMessage(`Запись с ID=${editItemId} не найдена`);
                    else
                        setErrorMessage(`Ошибка при загрузке данных: ${error}`);
                }
            } finally {
                if (!ignore) setIsLoading(false);
            }
        }

        if (isAddSubMode) {
            setFormData(null);
            return;
        }

        let ignore = false;
        fetch();
        return () => {
            ignore = true;
        }
    }, []);

    function handleClearBtnClick() {
        setFormKey(formKey + 1);
    }

    function handleAddBtnClick() {
        const data = tryValidateAndGetFormData();
        if (data)
            onAdd(data);
    };

    function handleSaveBtnClick() {
        const data = tryValidateAndGetFormData();
        if (data)
            onSave(data);
    }

    function tryValidateAndGetFormData() {
        if (!formControlRef.current.validate()) {
            setSnackbarData({
                severity: "error",
                title: "Ошибка в заполнении!",
                message: "Необходимо исправить отмеченные поля"
            });
            return false;
        }

        return formControlRef.current.getData();
    }

    function tryGetInitData() {
        return formData;
    }

    function renderFooter(props) {
        return renderFooterFunc ? renderFooterFunc(props) : <BaseSimpleItemEditorFooter {...props}/>
    }

    return (
        <div className={cl.main}>
            <BaseSimpleItemEditorHeader
                isAddSubMode={isAddSubMode}
                editItemId={editItemId}
                customTextFunc={headerCustomTextFunc}
            />
            <div className={cl.scrollContent}>
                {isLoading && <LinearProgress/>}
                {!isLoading && errorMessage && <Alert variant="outlined" severity="error">{errorMessage}</Alert>}
                {!isLoading && !errorMessage && <ItemFormComponent
                    key={formKey}
                    initData={formData}
                    controlRef={formControlRef}
                    pageOptions={pageOptions}
                    setSnackbarData={setSnackbarData}
                    setLoadingOverlayData={setLoadingOverlayData}
                    readOnlyMode={readOnlyMode}
                />}
            </div>
            {!isLoading && !errorMessage && renderFooter({
                isAddSubMode: isAddSubMode,
                onAddBtnClick: handleAddBtnClick,
                onClearBtnClick: handleClearBtnClick,
                onSaveBtnClick: handleSaveBtnClick,
                onDeleteBtnClick: onDelete,
                readOnlyMode: readOnlyMode,
            })}
        </div>
    );
});

export default BaseSimpleItemEditor;